const machines = [
    {
        label: 'HAAS SL Fanuc 2006 Lathe',
        value: 'haas-sl-fanuc-2006'
    },
    {
        label: 'HAAS ST 2026 Lathe',
        value: 'haas-st-2026'
    },
    {
        label: 'HAAS VF Fanuc 1995-2013 Mill',
        value: 'haas-vf-fanuc-1995-2013'
    },
    {
        label: 'Doosan DNM 400 II Fanuc 0I TD 2015 Mill',
        value: 'doosan-dnm-400-i-fanuc-0i-TD-2015'
    }
];

export default machines;